module.exports = __webpack_public_path__ + "static/media/base.e9c3cb55.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scss/base.scss
// module id = 479
// module chunks = 0